<template>
    <div v-if="field">
        <div v-html="field.labelStyle" />
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object
        }
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Form/LabelStyle.vue